import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';

import styles from './styles.scss';

export default function Textarea({
    className,
    hasError,
    maxLength,
    value,
    size,
    builderInput = false,
    minRows = 2,
    maxRows = 5,
    ...rest
}) {
    const _className = classNames(styles.root, className, {
        [styles.error]: hasError,
        [styles.paddingRight]: maxLength,
        [styles[size]]: !!size,
        [styles.builderInput]: builderInput,
    });
    const _value = value || '';

    return (
        <div className={styles.container} style={{ color: rest.style?.color }}>
            <TextareaAutosize
                value={_value}
                className={_className}
                maxLength={maxLength}
                minRows={minRows}
                maxRows={maxRows}
                {...rest}
            />
            {maxLength && <span className={styles.counter}>{maxLength - _value.trim().length}</span>}
        </div>
    );
}

Textarea.propTypes = {
    className: PropTypes.string,
    hasError: PropTypes.bool,
    maxLength: PropTypes.number,
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
    size: PropTypes.oneOf(['normal']),
    value: PropTypes.string,
    builderInput: PropTypes.bool,
};
